import { useContext } from 'react'
import { AxiosContext } from 'src/context/axiosContext'

export const useAxios = () => useContext(AxiosContext)